const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Uzņēmumstoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinārārstsasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Obligāts",
    },
  },
  salutation: {
    label: "Uzrunāšana",
    placeholder: "Atlasiet uzrunāšanu",
    errors: {
      required: "Uzrunāšana ir obligāta",
      invalid: "Atlasiet derīgu uzrunāšanu",
    },
  },
  firstName: {
    label: "Vārds",
    placeholder: "Jānis",
    errors: {
      authenticatedNameUpdateTrial:
        "Esat pieteicies, un savu vārdu mainīt nevarat.",
      required: "Vārds ir obligāts",
      minLength: "Vārdam jābūt vismaz 2 rakstzīmēm",
      maxLength: "Vārds nedrīkst būt garāks par 50 rakstzīmēm",
    },
  },
  lastName: {
    label: "Uzvārds",
    placeholder: "Bērziņš",
    errors: {
      authenticatedNameUpdateTrial:
        "Esat pieteicies, un savu vārdu mainīt nevarat.",
      required: "Uzvārds ir obligāts",
      minLength: "Uzvārdam jābūt vismaz 2 rakstzīmēm",
      maxLength: "Uzvārds nedrīkst būt garāks par 50 rakstzīmēm",
    },
  },
  email: {
    label: "E-pasts",
    placeholder: "janis.berzins@piemers.lv",
    description:
      "Lūdzu, ievadiet personīgu e-pasta adresi, nevis koplietojamu e-pasta adresi.",
    prefixWarningTitle: "Atrasta koplietojama pastkaste",
    prefixWarningDescription:
      "Mēs iesakām izmantot personīgu e-pasta adresi labākai un personalizētākai pieredzei",
    errors: {
      authenticatedEmailUpdateTrial:
        "Esat pieteicies, un savu e-pasta adresi mainīt nevarat.",
      required: "E-pasts ir obligāts",
      invalidEmail: "Lūdzu, ievadiet derīgu e-pasta adresi",
      emailAssociatedWithYourAccount:
        "Jūsu e-pasta adrese ir saistīta ar jūsu kontu un to nevar mainīt.",
    },
  },
  confirmEmail: {
    label: "Apstipriniet e-pastu",
    placeholder: "janis.berzins@piemers.lv",
    errors: {
      authenticatedEmailUpdateTrial:
        "Esat pieteicies, un savu e-pasta adresi mainīt nevarat.",
      required: "E-pasta apstiprinājums ir obligāts",
      invalidEmail: "Lūdzu, ievadiet derīgu e-pasta adresi",
      emailMatchError: "E-pasta adreses nesakrīt",
    },
  },
  password: {
    label: "Parole",
    placeholder: "Ievadiet savu paroli",
    errors: {
      required: "Parole ir obligāta",
    },
  },
  confirmPassword: {
    label: "Apstipriniet paroli",
    placeholder: "Apstipriniet savu paroli",
    errors: {
      required: "Paroles apstiprinājums ir obligāts",
      passwordMatchError: "Paroles nesakrīt",
    },
  },
  addressLine1: {
    label: "Adreses rinda 1",
    placeholder: "Brīvības iela 123",
    errors: {
      required: "Adreses rinda 1 ir obligāta",
      minLength: "Adreses rindai 1 jābūt vismaz 5 rakstzīmēm",
      maxLength: "Adreses rinda 1 nedrīkst būt garāka par 100 rakstzīmēm",
    },
  },
  addressLine2: {
    label: "Adreses rinda 2",
    placeholder: "Dzīvoklis 4B",
    errors: {
      required: "Adreses rinda 2 ir obligāta",
      maxLength: "Adreses rinda 2 nedrīkst būt garāka par 100 rakstzīmēm",
    },
  },
  city: {
    label: "Pilsēta",
    placeholder: "Rīga",
    errors: {
      required: "Pilsēta ir obligāta",
      minLength: "Pilsētai jābūt vismaz 2 rakstzīmēm",
      maxLength: "Pilsēta nedrīkst būt garāka par 50 rakstzīmēm",
    },
  },
  country: {
    label: "Valsts",
    placeholder: "Izvēlieties valsti",
    errors: {
      required: "Valsts ir obligāta",
      invalid: "Lūdzu, izvēlieties derīgu valsti",
    },
  },
  state: {
    label: "Štats",
    placeholder: "Atlasiet štatu",
    errors: {
      required: "Štats ir obligāts",
      invalid: "Atlasiet derīgu štatu",
    },
  },
  jurisdiction: {
    label: "Licences jurisdikcija",
    placeholder: "Atlasiet licences jurisdikciju",
    errors: {
      required: "Licences jurisdikcija ir obligāta",
      invalid: "Atlasiet derīgu jurisdikciju",
    },
  },
  zipCode: {
    label: "Pasta indekss",
    placeholder: "LV-1050",
    errors: {
      required: "Pasta indekss ir obligāts",
      invalid: "Lūdzu, ievadiet derīgu pasta indeksu",
    },
  },
  role: {
    label: "Loma",
    placeholder: "Atlasiet savu lomu",
    errors: {
      required: "Lūdzu, atlasiet savu lomu",
      invalid: "Atlasiet derīgu lomu",
    },
  },
  businessType: {
    label: "Uzņēmuma tips",
    placeholder: "Atlasiet uzņēmuma tipu",
    errors: {
      required: "Uzņēmuma tips ir obligāts",
      invalid: "Atlasiet derīgu uzņēmuma tipu",
    },
  },
  businessName: {
    label: "Uzņēmuma nosaukums",
    placeholder: "Ievadiet uzņēmuma nosaukumu",
    errors: {
      required: "Uzņēmuma nosaukums ir obligāts",
      minLength: "Uzņēmuma nosaukumam jābūt vismaz 2 rakstzīmēm",
      maxLength: "Uzņēmuma nosaukums nedrīkst būt garāks par 100 rakstzīmēm",
    },
  },
  businessSearch: {
    label: "Uzņēmuma meklēšana:",
    addNewAccount: "Pievienot jaunu uzņēmuma kontu",
    canNotFindBusiness: "Nevarat atrast savu uzņēmumu?",
    guideline:
      "Lūdzu, ievadiet savu pasta indeksu un pēc tam atlasiet no zemāk esošā saraksta.",
    guidelineForNameSearch:
      "Lūdzu, ievadiet pilnu uzņēmuma nosaukumu un pēc tam atlasiet no saraksta.",
    placeholder: "Kur jūs strādājat?",
    noResults: "Nav atrasts neviens rezultāts",
    searching: "Meklē...",
    selectedBusinessHeading: "Atlasītais uzņēmums:",
    selectedBusinessNotCorrect: "Nav pareizi?",
    selectedBusinessTryAgain: "Mēģiniet vēlreiz",
    selectedBusinessDismiss: "Noraidīt uzņēmumu",
    resultsFound: {
      singular: "Atrasts 1 uzņēmums",
      plural: "Atrasti vairāki uzņēmumi",
    },
    errors: {
      network:
        "Rodas problēmas, veidojot savienojumu ar uzņēmumu meklēšanas pakalpojumu. Lūdzu, mēģiniet vēlreiz vēlāk.",
    },
  },
  explicitConsent: {
    label:
      "Atzīmējot šo rūtiņu, es piekrītu Elanco lietošanas noteikumiem un apstiprinu, ka Elanco vāks un apstrādās manus personas datus saskaņā ar Elanco privātuma politiku",
    errors: {
      required: "E-pasta piekrišana ir obligāta",
    },
  },
  explicitSmsConsent: {
    label:
      "Atzīmējot šo lodziņu, es piekrītu saņemt Elanco mārketinga paziņojumus, izmantojot SMS/īsziņu.",
    errors: {
      required: "Nepieciešama piekrišana SMS",
    },
  },
  telephone: {
    label: "Personīgais tālrunis",
    placeholder: "Ievadiet savu personīgo tālruņa numuru",
    dialCodeLabel: "Kods",
    dialCodePlaceholder: "Meklēt valsti…",
    errors: {
      invalid: "Lūdzu, ievadiet derīgu tālruņa numuru.",
    },
  },
  businessTelephone: {
    label: "Uzņēmuma tālrunis",
    placeholder: "Ievadiet uzņēmuma tālruņa numuru",
    dialCodeLabel: "Kods",
    dialCodePlaceholder: "Meklēt valsti…",
    errors: {
      invalid: "Lūdzu, ievadiet derīgu tālruņa numuru.",
    },
  },
  professionalNumber: {
    label: "Profesionālais numurs",
    placeholder: "1234567",
    errors: {
      required: "Lūdzu, ievadiet profesionālo numuru",
      maxLength: "Ievade pārsniedz rakstzīmju limitu",
    },
  },
  addressSearch: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  businessSearchField: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  checkbox: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  combobox: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  datePicker: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  dateRange: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  dateTime: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  emailField: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  fileInput: {
    errors: {
      required: "Lūdzu, atlasiet failu",
    },
  },
  number: {
    errors: {
      required: "Lūdzu, ievadiet skaitli",
      minValue: "Lūdzu, ievadiet vērtību, kas ir lielāka par minimālo",
      maxValue: "Lūdzu, ievadiet vērtību, kas ir mazāka par maksimālo",
    },
  },
  passwordField: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  rangeSlider: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  select: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  telephoneField: {
    errors: {
      required: "Lūdzu, ievadiet tikai ciparus",
      invalidTelephone: "Lūdzu, ievadiet derīgu tālruņa numuru",
      invalidFormat: "Nederīgs numura formāts",
    },
  },
  text: {
    errors: {
      required:
        "Lūdzu, izmantojiet tikai burtus (A-Z), ciparus (0-9) un bez simboliem",
      maxLength: "Ievade pārsniedz rakstzīmju limitu",
      minLength: "Ievadei jābūt vismaz 2 rakstzīmēm",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "Šis lauks ir obligāts",
    },
  },
  form: {
    errors: {
      generic: "Iesniedzot veidlapu, radās kļūda. Lūdzu, mēģiniet vēlreiz.",
      reportAnIssue: "Lūdzu, ziņojiet par problēmu.",
      configuration: "Konfigurācijas kļūda",
      noFormQuestionsAvailable: "Veidlapas jautājumi nav pieejami.",
      formComponentLoad:
        "Veidlapas komponentu nevarēja ielādēt neatbalstīta lauka dēļ.",
      code: "Kods",
      type: "Tips",
      missingRequiredFields:
        "Šajā veidlapā trūkst obligāto lauku (E-pasts un/vai Piekrišana). Lūdzu, sazinieties ar administratoru, lai labotu veidlapas konfigurāciju.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Veterinārārsts",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Ražotājs - jaukts/cits",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Mazumtirgotājs",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Aitu audzētājs",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinārārsts",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veterinārārsts", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinārārsts, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinārārstsavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinārārstsasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinārārstsasema - Veterinārārsts",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinārārstsasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinārārstsasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinārārsts",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Kungs",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Kungs",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Kundze",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Kundze/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesors",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
